const mxaUiType = Object.freeze({
  OLD: 'old',
  NEW: 'new'
})

export { mxaUiType }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/MxaTypeEnum.js